import { render, staticRenderFns } from "./RsaSchedaEsameObiettivoGeneraleEsameCardiologicoEditComponent.vue?vue&type=template&id=37a8e8f3"
import script from "./RsaSchedaEsameObiettivoGeneraleEsameCardiologicoEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaEsameObiettivoGeneraleEsameCardiologicoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports